import * as React from 'react';
import { Field } from 'react-final-form';
export const Condition = (props) => (<Field name={props.when} subscription={{ value: true }}>
        {({ input: { value } }) => (value ? props.children : null)}
    </Field>);
export const ConditionNot = (props) => (<Field name={props.when} subscription={{ value: true }}>
        {({ input: { value } }) => (!!value && value !== props.isNot ? props.children : null)}
    </Field>);
export default Condition;
